"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dates = require("./dates");

Object.keys(_dates).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _dates[key];
    }
  });
});

var _progress = require("./progress");

Object.keys(_progress).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _progress[key];
    }
  });
});

var _status = require("./status");

Object.keys(_status).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _status[key];
    }
  });
});
exports.reducer = reducer;

var _assert = require("@swarm2/assert");

var Status = _interopRequireWildcard(_status);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var root = action.root,
      character = action.character,
      fixedNow = action.createdAt;

  (0, _assert.assert)(character.achievements === state, "char.achievements doesnt match state", { character: character, state: state });
  return Status.updatedDates(root, { character: character, fixedNow: fixedNow });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvYWNoaWV2ZW1lbnRzL2luZGV4LmpzIl0sIm5hbWVzIjpbInJlZHVjZXIiLCJTdGF0dXMiLCJzdGF0ZSIsImFjdGlvbiIsInJvb3QiLCJjaGFyYWN0ZXIiLCJmaXhlZE5vdyIsImNyZWF0ZWRBdCIsImFjaGlldmVtZW50cyIsInVwZGF0ZWREYXRlcyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFNQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7Ozs7QUFDQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBSEE7O0FBSUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO1FBRWdCQSxPLEdBQUFBLE87O0FBVGhCOztJQUdZQyxNOzs7O0FBTUwsU0FBU0QsT0FBVCxHQUFnRTtBQUFBLE1BQS9DRSxLQUErQyx1RUFBaEMsRUFBZ0M7QUFBQSxNQUE1QkMsTUFBNEI7QUFBQSxNQUM5REMsSUFEOEQsR0FDdEJELE1BRHNCLENBQzlEQyxJQUQ4RDtBQUFBLE1BQ3hEQyxTQUR3RCxHQUN0QkYsTUFEc0IsQ0FDeERFLFNBRHdEO0FBQUEsTUFDbENDLFFBRGtDLEdBQ3RCSCxNQURzQixDQUM3Q0ksU0FENkM7O0FBRXJFLHNCQUNFRixVQUFVRyxZQUFWLEtBQTJCTixLQUQ3QixFQUVFLHNDQUZGLEVBR0UsRUFBQ0csb0JBQUQsRUFBWUgsWUFBWixFQUhGO0FBS0EsU0FBT0QsT0FBT1EsWUFBUCxDQUFvQkwsSUFBcEIsRUFBMEIsRUFBQ0Msb0JBQUQsRUFBWUMsa0JBQVosRUFBMUIsQ0FBUDtBQUNEIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbmltcG9ydCB7YXNzZXJ0fSBmcm9tIFwiQHN3YXJtMi9hc3NlcnRcIlxuaW1wb3J0IHR5cGUge0ZhbmN5QWN0aW9ufSBmcm9tIFwiLi4vYWN0aW9uLWJhc2VcIlxuaW1wb3J0IHR5cGUge1N0YXRlfSBmcm9tIFwiLi9kYXRlc1wiXG5pbXBvcnQgKiBhcyBTdGF0dXMgZnJvbSBcIi4vc3RhdHVzXCJcblxuZXhwb3J0ICogZnJvbSBcIi4vZGF0ZXNcIlxuZXhwb3J0ICogZnJvbSBcIi4vcHJvZ3Jlc3NcIlxuZXhwb3J0ICogZnJvbSBcIi4vc3RhdHVzXCJcblxuZXhwb3J0IGZ1bmN0aW9uIHJlZHVjZXIoc3RhdGU6IFN0YXRlID0ge30sIGFjdGlvbjogRmFuY3lBY3Rpb24pOiBTdGF0ZSB7XG4gIGNvbnN0IHtyb290LCBjaGFyYWN0ZXIsIGNyZWF0ZWRBdDogZml4ZWROb3d9ID0gYWN0aW9uXG4gIGFzc2VydChcbiAgICBjaGFyYWN0ZXIuYWNoaWV2ZW1lbnRzID09PSBzdGF0ZSxcbiAgICBcImNoYXIuYWNoaWV2ZW1lbnRzIGRvZXNudCBtYXRjaCBzdGF0ZVwiLFxuICAgIHtjaGFyYWN0ZXIsIHN0YXRlfSxcbiAgKVxuICByZXR1cm4gU3RhdHVzLnVwZGF0ZWREYXRlcyhyb290LCB7Y2hhcmFjdGVyLCBmaXhlZE5vd30pXG59XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/firebase/characters2/achievements/index.js
// module id = 373
// module chunks = 0